import { api } from "@/lib/api";

export interface TeamMember {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  get_display_name: string;
}

/**
 * Hook to fetch all team members in the current user's organization
 */
export function useTeamMembers() {
  return api.useGet<TeamMember[]>("/api/organization/team/");
}
